import './PrivacyPolicy.scss';
import { Logo } from '@/components/logo';
import { RenderedLegalDocument } from '@/components/pages/RenderedLegalDocument';

// TCX-668: renders the currently published Privacy Policy (audience "all") from
// the legal-documents admin system, so this page stays in sync with whatever an
// admin most recently publishes (previously hard-coded static content).
export function PrivacyAndPolicy() {
  return (
    <div className="privacy-policy">
      <Logo />
      <RenderedLegalDocument documentType="privacy" audience="all" />
    </div>
  );
}
